import React from 'react';
import { Package, MapPin, User, CheckCircle2, ShoppingBag } from 'lucide-react';

function OrderItem({ order, onClick, isLast, disabled = false }) {
  const getStatusColor = (status) => {
    const statusLower = (status || '').toLowerCase();
    switch (statusLower) {
      case 'pending':
        return 'bg-gray-100 text-gray-700';
      case 'encamino':
        return 'bg-blue-100 text-blue-700';
      case 'picked_up':
      case 'recogido':
        return 'bg-brand-green/20 text-brand-green';
      case 'cancelado':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };

  const getStatusText = (status) => {
    const statusLower = (status || '').toLowerCase();
    switch (statusLower) {
      case 'pending':
        return 'Pendiente';
      case 'encamino':
        return 'En camino';
      case 'picked_up':
      case 'recogido':
        return 'Recogido';
      case 'cancelado':
        return 'Cancelado';
      default:
        return status;
    }
  };

  return (
    <div className={!isLast ? 'border-b border-gray-100' : ''}>
      <button
        onClick={onClick}
        disabled={disabled}
        className={`
          w-full text-left px-5 py-4 transition-colors
          ${disabled
            ? 'cursor-not-allowed bg-gray-50'
            : 'hover:bg-brand-primary/5 active:bg-brand-primary/10 cursor-pointer'
          }
        `}
      >
        <div className="flex items-start gap-3">
          {/* Sequence Badge */}
          <div className={`
            flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm
            ${disabled ? 'bg-gray-200 text-gray-500' : 'bg-brand-gold text-white'}
          `}>
            {order.sequence}
          </div>

          {/* Order Info */}
          <div className="flex-1 min-w-0">
            {/* Customer Name */}
            <div className="flex items-center gap-2 mb-1">
              <User className="w-4 h-4 text-gray-500 flex-shrink-0" />
              <span className="font-semibold text-gray-900 truncate">
                {order.customer_name}
              </span>
            </div>

            {/* Store/Provider Info */}
            {order.store_name && (
              <div className="flex items-start gap-2 mb-1">
                <ShoppingBag className="w-4 h-4 text-gray-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-600 line-clamp-2">
                  {order.store_name}
                </span>
              </div>
            )}

            {/* Address */}
            {order.address && (
              <div className="flex items-center gap-2 mb-2">
                <MapPin className="w-4 h-4 text-gray-500 flex-shrink-0" />
                <span className="text-xs text-gray-500 truncate">
                  {order.address}
                </span>
              </div>
            )}

            {/* Status Badge */}
            <div className="flex items-center gap-2">
              <span className={`
                inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium
                ${getStatusColor(order.status)}
              `}>
                {order.is_submitted && (
                  <CheckCircle2 className="w-3.5 h-3.5" />
                )}
                {getStatusText(order.status)}
              </span>
              
              {/* ID Badge */}
              <span className="text-xs text-gray-400">
                ID: {order.id}
              </span>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}

export default OrderItem;